import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { injectIntl as withIntl } from 'react-intl';

import WithOnBeforeProductConfig from '@shopDetails/HOCs/WithOnBeforeProductConfig';
import WithAgeValidation from '@shopDetails/HOCs/WithAgeValidation';
import { goBack } from '@shared/actions';
import getCanViewCart from '@core/reducers/cart/selectors/getCanViewCart';
import getCartHasItems from '@core/reducers/cart/selectors/getCartHasItems';
import getShop from '@shopDetails/selectors/getShop';
import getIsFetchingShop from '@core/reducers/shop/selectors/getIsFetchingShop';
import getIsMenuFetched from '@core/reducers/menu/selectors/getIsMenuFetched';
import { getVerticalForSelectedShop } from '@shopDetails/selectors';
import getFallbackUrl from '@shopDetails/selectors/getFallbackUrl';

import { getCountryShortName } from '@shared/selectors';
import getIsFetchingMenu from '@core/reducers/menu/selectors/getIsFetchingMenu';
import getMenuWithDiscounts from '@core/reducers/menu/selectors/getMenuWithDiscounts';
import getIsShelvesMenuLayout from '@core/reducers/menu/selectors/getIsShelvesMenuLayout';
import trackBackButtonClicked from '@shopDetails/tracking/actions/trackBackButtonClicked';
import WithShopDetails from './WithShopDetails';
import messages from './messages';

const mapStateToProps = createStructuredSelector({
  isFetchingShop: getIsFetchingShop,
  cartHasItems: getCartHasItems,
  shop: getShop,
  hasFetchedMenu: getIsMenuFetched,
  canViewCart: getCanViewCart,
  vertical: getVerticalForSelectedShop,
  fallbackUrl: getFallbackUrl,
  isFetchingMenu: getIsFetchingMenu,
  menu: getMenuWithDiscounts,
  countryCode: getCountryShortName,
  isShelvesMenu: getIsShelvesMenuLayout,
});

const mapDispatchToProps = {
  goBack,
  trackBackButtonClicked,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withOnBeforeProductConfig = T =>
  WithOnBeforeProductConfig(T, { unmount: false });

const withAgeValidation = T =>
  WithAgeValidation(T, {
    errorMsg: messages.shopDetails_age_validation_error,
    subtitle: messages.shopDetails_age_validation_subtitle,
  });

export default compose(
  withOnBeforeProductConfig,
  withAgeValidation,
  withConnect,
  withIntl,
  WithShopDetails,
);
